<template>
  <div class="closing-date">
    <h2>Closing date widget</h2>
    <p>Closing date: <span class="msg">{{ msg }}</span></p>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'closing-date',
  props: ['cutoff'],
  computed: {
    msg: function () {
      var cutoffDate = moment(this.cutoff)
      var today = moment()
      var daysToGo = cutoffDate.diff(today, 'days')
      var text

      switch (Math.sign(daysToGo)) {
        case 1:
          text = '' + daysToGo + ' days to go'
          break
        case 0:
          text = 'Closing today!'
          break
        case -1:
          text = 'Closed ' + (0 - daysToGo) + ' days ago'
          break
      }

      return text
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  font-weight: normal;
}
span {
  font-weight: bold; color: #42b983;
}

</style>



// WEBPACK FOOTER //
// ClosingDate.vue?35884444